import React from 'react'
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip } from '@mui/material'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, generators, filters = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  return (
    <Box>
      <PageHeader
        title="Verbindlichkeiten"
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Verbindlichkeiten' },
        ]}
        actions={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="outlined" size="small"
              color={filters.recurring === '1' ? 'primary' : 'inherit'}
              onClick={() => router.visit(`${basePath}/payables?recurring=1`)}
            >
              Wiederkehrend
            </Button>
            <Button variant="outlined" size="small"
              color={filters.recurring === '0' ? 'primary' : 'inherit'}
              onClick={() => router.visit(`${basePath}/payables?recurring=0`)}
            >
              Einmalig
            </Button>
            {filters.recurring && (
              <Button variant="text" size="small"
                onClick={() => router.visit(`${basePath}/payables`)}
              >
                Alle
              </Button>
            )}
          </Box>
        }
      />

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Kreditor</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Kostenart</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Beschreibung</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Betrag (brutto)</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Frequenz</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Gültig ab</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Gültig bis</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Art</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {generators.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Verbindlichkeiten vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {generators.map((g) => (
              <TableRow key={g.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`${basePath}/payables/${g.id}`)}
              >
                <TableCell>{g.contact_name}</TableCell>
                <TableCell>{g.cost_category_name}</TableCell>
                <TableCell>{g.description}</TableCell>
                <TableCell align="right"><FormattedCurrency value={g.gross_amount} /></TableCell>
                <TableCell>{g.frequency || '—'}</TableCell>
                <TableCell>{g.valid_from}</TableCell>
                <TableCell>{g.valid_until || '—'}</TableCell>
                <TableCell>
                  <Chip label={g.recurring ? 'Wiederkehrend' : 'Einmalig'} size="small"
                    color={g.recurring ? 'primary' : 'default'} variant="outlined" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
